<div class="row m-0">
  <div class="col-12 p-0">
      <div>
          <kendo-grid [kendoGridBinding]="numberConfigurationView" [sortable]="true" [resizable]="true" [filterable]="enableFilter" [reorderable]="true" [pageSize]="15" [filterable]="false" [pageable]="true" id="grvEDMOrgList" (edit)="editRowData($event)" (save)="UpdateRowData($event)" (cancel)="cancelRowData($event)" (add)="addHandler()">
              <ng-template kendoPagerTemplate>
                  <div class="k-pager-left">
                      <kendo-pager-info></kendo-pager-info>
                  </div>
                  <div class="k-pager-right">
                      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                      <kendo-pager-input></kendo-pager-input>
                      <kendo-pager-next-buttons></kendo-pager-next-buttons>
                  </div>
              </ng-template>
              <ng-template kendoGridToolbarTemplate>
                  <div class="k-grid-toolbar-content d-flex justify-content-end">
                      <div class="pagination-container">
                          <p id="lblShowDetails">Show</p>
                          <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                          </kendo-pager-page-sizes>
                          <span>Items</span>
                      </div>
                      <div class="divider-container d-none d-md-block" id="imgDivider">
                          <span></span>
                      </div>
                      <div class="icons-container">
                          <button kendoGridAddCommand>
                              <i class="fa fa-plus-circle" matTooltip="Add" aria-hidden="true"></i>
                          </button>
                      </div>
                  </div>
              </ng-template>
              <kendo-grid-column title="Sl.No." [width]="60">
                  <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                      {{rowIndex+1}}
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Module Name" field="module_Name" [width]="200">
                  <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                      <span class="no-wrap" eipTooltip="{{dataItem.module_Name}}" eipTooltipPosition="auto">{{dataItem.module_Name}}</span>
                  </ng-template>
                  <ng-template kendoGridEditTemplate let-dataItem="dataItem" width="150" let-rowIndex="rowIndex">
                      <EIPAutoComplete ShowTextValueField='N' TextField="cedDescription"  ValueField="cedId" [defaultValue]='selectedModuleId' WaterMarkText="Module Name" setId="moduleId" [clearValue]='selectedModuleClear' [dataSource]='moduleList' *ngIf="this.isNewRow" (valueChange)='changeModuleList($event)' [IsCascading]='true'>
                      </EIPAutoComplete>
                      <span *ngIf="!isNewRow" class="no-wrap" eipTooltip="{{dataItem.module_Name}}" eipTooltipPosition="auto">{{dataItem.module_Name}}</span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Serial No Length" field="sl_No_Length" [width]="100">
                  <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                      <span class="no-wrap" eipTooltip="{{dataItem.sl_No_Length}}" eipTooltipPosition="auto">{{dataItem.sl_No_Length}}</span>
                  </ng-template>
                  <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                      <mat-form-field WaterMarkText="Serial No Length">
                          <input matInput type="number" (change)="updataSlNo($event)" formControlName="sl_No_Length" [value]="dataItem.sl_No_Length">
                      </mat-form-field>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Created By" field="created_By" [width]="110">
                  <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                      <span class="no-wrap" eipTooltip="{{dataItem.created_By}}" eipTooltipPosition="auto">{{dataItem.created_By}}</span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Created On" field="created_On" [width]="110">
                  <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                      <span class="no-wrap" eipTooltip="{{dataItem.created_On | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.created_On | date:'dd-MMM-yyyy'}}</span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Modified By" field="modified_By" [width]="110">
                  <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                      <span class="no-wrap" eipTooltip="{{dataItem.modified_By}}" eipTooltipPosition="auto">{{dataItem.modified_By}}</span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Modified On" field="modified_On" [width]="110">
                  <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                      <span class="no-wrap" eipTooltip="{{dataItem.modified_On | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.modified_On | date:'dd-MMM-yyyy'}}</span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Is Active" [width]="100" field="is_Active">
                  <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                      <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [checked]="dataItem.is_Active" [disabled]="true" [size]="small"></kendo-switch>
                  </ng-template>
                  <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                      <mat-slide-toggle [checked]="dataItem.is_Active" color="primary" (change)="changeActiveStatus($event)">
                      </mat-slide-toggle>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Actions" [width]="100">
                  <ng-template kendoGridCellTemplate let-isNew="isNew" let-rowIndex="rowIndex" let-dataItem="dataItem">
                      <div>
                          <button kendoGridEditCommand class="k-grid-add-command">
                              <i class="fa fa-pencil icon-size mr-2 eip-link" title="Edit" style="font-size: 1.25em; cursor: pointer;" id="" aria-hidden="true"></i>
                          </button>
                          <button kendoGridSaveCommand type="button" class="k-grid-add-command">
                              <i class="fa fa-save icon-size mr-2 eip-link" title="Save" style="font-size: 1.25em; cursor: pointer;" id="" aria-hidden="true"></i>
                          </button>
                          <button kendoGridCancelCommand type="button" class="k-grid-add-command">
                              <i class="fa fa-times-circle icon-size mr-2 eip-link" title="Cancel" style="font-size: 1.25em; cursor: pointer;" id="" aria-hidden="true"></i>
                          </button>
                      </div>
                  </ng-template>
              </kendo-grid-column>
          </kendo-grid>
      </div>
  </div>
</div>